var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1075 1.58603C19.5379 0.430923 18.9197 0.218454 17.661 0.137656C16.4036 0.040399 13.2418 0 10.5026 0C7.75819 0 4.59506 0.0403991 3.339 0.13616C2.08294 0.218454 1.46344 0.429426 0.888563 1.58603C0.301875 2.73965 0 4.72668 0 8.22494C0 8.22793 0 8.22943 0 8.22943C0 8.23242 0 8.23392 0 8.23392V8.23691C0 11.7202 0.301875 13.7222 0.888563 14.8638C1.46344 16.019 2.08162 16.2284 3.33769 16.3257C4.59506 16.4095 7.75819 16.4589 10.5026 16.4589C13.2418 16.4589 16.4036 16.4095 17.6623 16.3272C18.921 16.2299 19.5392 16.0204 20.1088 14.8653C20.7008 13.7237 21 11.7217 21 8.2384C21 8.2384 21 8.23392 21 8.23092C21 8.23092 21 8.22793 21 8.22643C21 4.72668 20.7008 2.73965 20.1075 1.58603ZM7.875 12.7182V3.74065L14.4375 8.22943L7.875 12.7182Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.3e5094b46b04b999fb80f97ea5d7c4d6.svg";
export { ForwardRef as ReactComponent };